module.exports = __webpack_public_path__ + "static/media/column.caeedd4a.svg";